var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customBarCodes"},_vm._l((_vm.products),function(row){return _c('div',{key:row.id,staticStyle:{"background-color":"white"}},[_c('center',[_c('barcode',{attrs:{"value":'(' + row.id + ') ' + row.price + 'DT',"options":{
          lineColor: '#000',
          text: '(' + row.id + ') ' + row.price + 'DT',
          fontOptions: 'bold',
          fontSize: 30,
        }}}),_c('div',{staticClass:"customP"},[_c('b',[_vm._v(_vm._s(row.name))])]),_c('div',{staticClass:"customP"},[_c('b',[_vm._v(_vm._s(_vm.getDate(row.createdOn)))])])],1),_c('br'),_c('br')],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }